export default __webpack_public_path__ + "static/media/avatar.41c95564.png";